import WebHttpClient from '~src/httpClient/WebHttpClient';

import { IGetSiteEncryptionKeyResult } from '../models/ExtractEncryptionModels';
import { ActivateSiteEncryptionKeyRequest, ActivateSiteEncryptionKeyResult } from '../serverApi/requests/ActivateSiteEncryptionKeyRequest';
import { DeactivateSiteEncryptionKeyRequest, DeactivateSiteEncryptionKeyResult } from '../serverApi/requests/DeactivateSiteEncryptionKeyRequest';
import { GetSiteEncryptionKeyRequest } from '../serverApi/requests/GetSiteEncryptionKeyRequest';
import { GetSiteEncryptionSingleKeyHistoryRequest, GetSiteEncryptionSingleKeyHistoryResult } from '../serverApi/requests/GetSiteEncryptionSingleKeyHistoryRequest';
import { GetSiteEncryptionKeyPolicyRequest, GetSiteEncryptionKeyPolicyResult } from '../serverApi/requests/GetSiteEncryptionSingleKeyPolicyRequest';
import  { RegisterSiteEncryptionKeyRequest, RegisterSiteEncryptionKeyResult } from '../serverApi/requests/RegisterSiteEncryptionKeyRequest';
import { TestEncryptionKeyConnectionRequest, TestEncryptionKeyConnectionResult } from '../serverApi/requests/TestEncryptionKeyConnectionRequest';


export function retrieveSiteEncryptionKey(): Promise<IGetSiteEncryptionKeyResult>  {
  const isComplete = (result: IGetSiteEncryptionKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(new GetSiteEncryptionKeyRequest({}));
}

export function registerSiteEncryptionKey(request: RegisterSiteEncryptionKeyRequest): Promise<RegisterSiteEncryptionKeyResult>  {
  const isComplete = (result: RegisterSiteEncryptionKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export function getSiteEncryptionSingleKeyHistory(request: GetSiteEncryptionSingleKeyHistoryRequest): Promise<GetSiteEncryptionSingleKeyHistoryResult>  {
  const isComplete = (result: GetSiteEncryptionSingleKeyHistoryResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export function getSiteEncryptionKeyPolicy(request: GetSiteEncryptionKeyPolicyRequest): Promise<GetSiteEncryptionKeyPolicyResult>  {
  const isComplete = (result: GetSiteEncryptionKeyPolicyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export function activateSiteEncryptionKey(request: ActivateSiteEncryptionKeyRequest): Promise<ActivateSiteEncryptionKeyResult>  {
  const isComplete = (result: ActivateSiteEncryptionKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export function deactivateSiteEncryptionKey(request: DeactivateSiteEncryptionKeyRequest): Promise<DeactivateSiteEncryptionKeyResult>  {
  const isComplete = (result: DeactivateSiteEncryptionKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export function testEncryptionKeyConnection(request: TestEncryptionKeyConnectionRequest): Promise<TestEncryptionKeyConnectionResult>  {
  const isComplete = (result: TestEncryptionKeyConnectionResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export const ExtractEncryptionKeyService = {
  retrieveSiteEncryptionKey: retrieveSiteEncryptionKey,
  registerSiteEncryptionKey: registerSiteEncryptionKey,
  getSiteEncryptionSingleKeyHistory: getSiteEncryptionSingleKeyHistory,
  getSiteEncryptionKeyPolicy: getSiteEncryptionKeyPolicy,
  activateSiteEncryptionKey: activateSiteEncryptionKey,
  deactivateSiteEncryptionKey: deactivateSiteEncryptionKey,
  testEncryptionKeyConnection: testEncryptionKeyConnection
};